/* ==========================================================================
   Amour & Nectar — ameliorations UX (panier, fiche produit, collections)
   Charge en defer depuis layout/theme.liquid. Textes : window.anStrings.
   ========================================================================== */
(function () {
  var strings = window.anStrings || {};
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  function sectionsToRender() {
    return document.querySelector('cart-drawer') ? 'cart-drawer,cart-icon-bubble' : 'cart-icon-bubble';
  }

  /* ---------- Ajout direct au panier (echantillon, suggestions, quiz) ----------
     data-an-add-variant accepte un id ou une liste d'ids separes par des virgules. */
  function addToCart(variantId, button) {
    if (button) {
      button.setAttribute('aria-disabled', 'true');
      button.classList.add('is-loading');
    }
    return fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        items: String(variantId)
          .split(',')
          .map(function (id) {
            return { id: Number(id), quantity: 1 };
          }),
        sections: sectionsToRender(),
      }),
    })
      .then(function (response) {
        return response.json();
      })
      .then(function (state) {
        if (state.status) throw new Error(state.description || state.message);
        var drawer = document.querySelector('cart-drawer');
        if (drawer && typeof drawer.renderContents === 'function') {
          drawer.classList.remove('is-empty');
          drawer.renderContents({ id: variantId, sections: state.sections });
        } else {
          window.location = window.routes.cart_url;
        }
        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          publish(PUB_SUB_EVENTS.cartUpdate, { source: 'an-ux', productVariantId: variantId });
        }
      })
      .catch(function (error) {
        if (button) {
          var msg = document.createElement('p');
          msg.className = 'an-error caption';
          msg.textContent = error.message || strings.error;
          button.insertAdjacentElement('afterend', msg);
        }
      })
      .finally(function () {
        if (button) {
          button.removeAttribute('aria-disabled');
          button.classList.remove('is-loading');
        }
      });
  }

  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-an-add-variant], .an-reco__add[data-variant-id]');
    if (!button || button.getAttribute('aria-disabled') === 'true') return;
    event.preventDefault();
    addToCart(button.dataset.anAddVariant || button.dataset.variantId, button);
  });

  /* ---------- Choix des echantillons offerts (attribut de panier) ---------- */
  if (!customElements.get('an-cart-samples')) {
    customElements.define(
      'an-cart-samples',
      class extends HTMLElement {
        connectedCallback() {
          this.status = this.querySelector('.an-samples__status');
          this.custom = this.querySelector('.an-samples__custom');
          this.text = this.querySelector('.an-samples__text');
          this.timer = null;
          this.addEventListener('change', this.onChange.bind(this));
          this.text.addEventListener('input', this.schedule.bind(this));
        }

        mode() {
          var checked = this.querySelector('input[type="radio"]:checked');
          return checked ? checked.value : 'surprise';
        }

        onChange(event) {
          if (event.target.type !== 'radio') return;
          var custom = this.mode() === 'custom';
          this.custom.hidden = !custom;
          if (custom) this.text.focus();
          this.save();
        }

        schedule() {
          clearTimeout(this.timer);
          this.timer = setTimeout(this.save.bind(this), 700);
        }

        save() {
          var value = this.mode() === 'custom' ? this.text.value.trim() : this.dataset.surprise;
          var attributes = {};
          attributes[this.dataset.key] = value;
          fetch(root + 'cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ attributes: attributes }),
          })
            .then(
              function () {
                this.status.textContent = strings.saved || '';
              }.bind(this)
            )
            .catch(
              function () {
                this.status.textContent = strings.error || '';
              }.bind(this)
            );
        }
      }
    );
  }

  /* ---------- Suggestions dans le panier lateral ---------- */
  if (!customElements.get('an-cart-reco')) {
    customElements.define(
      'an-cart-reco',
      class extends HTMLElement {
        connectedCallback() {
          var url = this.dataset.url;
          if (!url) return;
          this.load(url + '&intent=complementary').then(
            function (shown) {
              if (!shown) return this.load(url + '&intent=related');
            }.bind(this)
          );
        }

        load(url) {
          return fetch(url)
            .then(function (response) {
              return response.text();
            })
            .then(
              function (text) {
                var html = new DOMParser().parseFromString(text, 'text/html');
                var reco = html.querySelector('.an-reco');
                var marker = html.querySelector('[data-shown]');
                var shown = marker ? Number(marker.dataset.shown) : 0;
                if (reco && shown > 0) {
                  this.querySelector('.an-cart-reco__content').innerHTML = reco.innerHTML;
                  this.hidden = false;
                }
                return shown > 0;
              }.bind(this)
            )
            .catch(function () {
              return false;
            });
        }
      }
    );
  }

  /* ---------- Barre d'achat fixe (mobile) ---------- */
  if (!customElements.get('an-sticky-atc')) {
    customElements.define(
      'an-sticky-atc',
      class extends HTMLElement {
        connectedCallback() {
          this.main = document.querySelector('#MainContent product-info .product-form__submit, #MainContent .product-form__submit');
          if (!this.main || !('IntersectionObserver' in window)) return;
          this.querySelector('.an-sticky-atc__button').addEventListener(
            'click',
            function () {
              this.main.click();
            }.bind(this)
          );
          new IntersectionObserver(
            function (entries) {
              var entry = entries[0];
              var passed = !entry.isIntersecting && entry.boundingClientRect.top < 0;
              var disabled = this.main.disabled || this.main.getAttribute('aria-disabled') === 'true';
              this.hidden = !passed || disabled;
              document.body.classList.toggle('an-sticky-atc-visible', passed && !disabled);
            }.bind(this)
          ).observe(this.main);
        }
      }
    );
  }

  /* ---------- Description produit : "Lire la suite" ---------- */
  document.querySelectorAll('#MainContent .product__description.rte').forEach(function (desc) {
    if (desc.scrollHeight < 420) return;
    desc.classList.add('an-clamp');
    var toggle = document.createElement('button');
    toggle.type = 'button';
    toggle.className = 'an-clamp__toggle link';
    toggle.textContent = strings.readMore || '+';
    toggle.setAttribute('aria-expanded', 'false');
    toggle.addEventListener('click', function () {
      var open = desc.classList.toggle('an-clamp--open');
      toggle.textContent = open ? strings.readLess : strings.readMore;
      toggle.setAttribute('aria-expanded', String(open));
    });
    desc.insertAdjacentElement('afterend', toggle);
  });

  /* ---------- Partage natif ---------- */
  document.querySelectorAll('[data-an-share]').forEach(function (button) {
    if (!navigator.share) return;
    button.hidden = false;
    button.addEventListener('click', function () {
      navigator.share({ title: button.dataset.title, url: button.dataset.url }).catch(function () {});
    });
  });

  /* ---------- Filtre "Contenance" regroupe : synchronise les cases cachees ---------- */
  document.addEventListener(
    'input',
    function (event) {
      var group = event.target;
      if (!group.matches || !group.matches('[data-an-group]')) return;
      group
        .closest('label')
        .querySelectorAll('[data-an-group-value]')
        .forEach(function (input) {
          input.checked = group.checked;
        });
    },
    true
  );

  /* ---------- Liens vers les collections : produits en stock par defaut ---------- */
  var collectionPath = /^(\/[a-z]{2}(-[a-z]{2})?)?\/collections\/[^\/]+\/?$/i;
  function rewrite(event) {
    var link = event.target.closest && event.target.closest('a[href]');
    if (!link || link.origin !== window.location.origin) return;
    if (!collectionPath.test(link.pathname) || link.search.indexOf('filter.') !== -1) return;
    var url = new URL(link.href);
    url.searchParams.set('filter.v.availability', '1');
    link.href = url.toString();
  }
  document.addEventListener('mousedown', rewrite, true);
  document.addEventListener('touchstart', rewrite, { capture: true, passive: true });
  document.addEventListener('keydown', function (event) {
    if (event.key === 'Enter') rewrite(event);
  }, true);
})();
